export const useDocumentAnnotationHighlight = () => {
  const highlightAnnotation = (annotationId: string) => {
    // querySelector element with data-annotaiton-id = annotationId
    // add class highlight
    const annotationElement = document.querySelector(
      `.inline-annotation[data-annotation-id="${annotationId}"]`
    );
    if (annotationElement) {
      annotationElement.classList.add("highlight");
      annotationElement.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  };

  const clearAnnotationsToHighlight = () => {
    const annotationElement = document.querySelector(
      `.inline-annotation.highlight`
    );
    if (annotationElement) {
      annotationElement.classList.remove("highlight");
    }
  };

  return { highlightAnnotation, clearAnnotationsToHighlight };
};
